import React from "react";
import { Routes, Route } from "react-router-dom";
import Tests from "../../pages/TestsQuiz/TestsQuiz";
import PlayTest from "../../pages/TestsQuiz/PlayTest";
import PATH from "../../constants/routes";

export default function QbankRoutes() {
  return (
    <Routes>
      <Route index element={<Tests />} />
      <Route path={`${PATH.PLAY_TEST_ROUTE}`} element={<PlayTest />} />
    </Routes>
  );
}
